'use strict';

var chunkS7FZ7BAB_js = require('./chunk-S7FZ7BAB.js');
var chunkM632V57T_js = require('./chunk-M632V57T.js');
var e = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var e__default = /*#__PURE__*/_interopDefault(e);

var c=e__default.default.div`
  display: flex;
  gap: ${chunkS7FZ7BAB_js.b.spacing_12};
  align-items: center;
  margin-bottom: ${chunkS7FZ7BAB_js.b.spacing_24};

  span {
    color: ${chunkS7FZ7BAB_js.c.grey_secondary_heading};
  }
  @media (min-width: 767px) {
    margin-bottom: ${chunkS7FZ7BAB_js.b.spacing_36};
  }
`,g=e__default.default.h3`
  font-size: ${chunkM632V57T_js.a.font_size_300};
  font-weight: ${chunkM632V57T_js.a.font_weight_semibold};
  line-height: ${chunkM632V57T_js.a.line_height_300};
  margin: ${chunkS7FZ7BAB_js.b.spacing_0};
`,d=e__default.default.footer`
  padding: ${chunkS7FZ7BAB_js.b.spacing_24} ${chunkS7FZ7BAB_js.b.spacing_20};
  @media (min-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`,_=e__default.default.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${chunkS7FZ7BAB_js.b.spacing_16};
  row-gap: ${chunkS7FZ7BAB_js.b.spacing_24};
  margin-bottom: ${chunkS7FZ7BAB_js.b.spacing_24};

  @media (min-width: 540px) {
    grid-template-columns: repeat(3, 1fr);
    column-gap: ${chunkS7FZ7BAB_js.b.spacing_24};
  }

  @media (min-width: 980px) {
    column-gap: 80px;
  }
`,m=e__default.default.div`
  height: auto;
`,f=e__default.default.p`
  font-size: ${chunkM632V57T_js.a.font_size_300};
  font-weight: ${chunkM632V57T_js.a.font_weight_semibold};
  line-height: ${chunkM632V57T_js.a.line_height_300};
  color: ${chunkS7FZ7BAB_js.c.text_default_text_primary};
  text-decoration: none;
  text-transform: uppercase;
  margin-bottom: ${chunkS7FZ7BAB_js.b.spacing_12}; 

`,h=e__default.default.ul`
  margin-bottom: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: ${chunkS7FZ7BAB_js.b.spacing_12};
  font-size: 0;

  & li a {
    font-size: ${chunkM632V57T_js.a.font_size_250};
    font-weight: ${chunkM632V57T_js.a.font_weight_medium};
    line-height: ${chunkM632V57T_js.a.line_height_300};
    color: ${chunkS7FZ7BAB_js.c.text_default_text_secondary};
    text-decoration: none;
    margin: 0;
    padding: 0;

    & li:first-child {
      margin-top: ${chunkS7FZ7BAB_js.b.spacing_4};

      & li a:hover,
      & li a:focus,
      & li a:active {
        color: ${chunkS7FZ7BAB_js.c.text_default_text_secondary};
      }
    }
  }

`,x=e__default.default.p`
  font-size: ${chunkM632V57T_js.a.font_size_250};
  font-weight: ${chunkM632V57T_js.a.font_weight_regular};
  line-height: ${chunkM632V57T_js.a.line_height_300};
  letter-spacing: -0.25px;
  text-align: center;
  color: ${chunkS7FZ7BAB_js.c.grey_secondary_heading};
  margin-top: ${chunkS7FZ7BAB_js.b.spacing_24};


`,$=e__default.default.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 767px) {
    flex-direction: row;
    gap: ${chunkS7FZ7BAB_js.b.spacing_32};
  }
  @media (min-width: 980px) {
    column-gap: 80px;
  }
`,y=e__default.default.div`
  display: flex;
  flex-direction: column;
  gap: ${chunkS7FZ7BAB_js.b.spacing_8};
`,u=e__default.default.div`
  display: flex;
  column-gap: ${chunkS7FZ7BAB_js.b.spacing_8};
`,w=e__default.default.ul`
  list-style: none;
  display: flex;
  column-gap: ${chunkS7FZ7BAB_js.b.spacing_20};
  padding: ${chunkS7FZ7BAB_js.b.spacing_0};
  margin: ${chunkS7FZ7BAB_js.b.spacing_0};
  margin-bottom: ${chunkS7FZ7BAB_js.b.spacing_24};

  & li a {
    width: ${chunkS7FZ7BAB_js.a.icon_size_40};
    height: ${chunkS7FZ7BAB_js.a.icon_size_40};
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
}

& li a > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
`,z=e__default.default.ul`
  list-style: none;
  display: flex;
  column-gap: ${chunkS7FZ7BAB_js.b.spacing_20};
  padding: ${chunkS7FZ7BAB_js.b.spacing_0};
  margin: ${chunkS7FZ7BAB_js.b.spacing_0};

  & li a {
    display: flex;
    width: auto;
    gap: ${chunkS7FZ7BAB_js.b.spacing_12};
    align-items: center;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }

  & li a > img {
    width: ${chunkS7FZ7BAB_js.a.icon_size_32};
    height: ${chunkS7FZ7BAB_js.a.icon_size_32};
    object-fit: cover;
  }
`,b=e__default.default.p`
  font-size: ${chunkM632V57T_js.a.font_size_250};
  font-weight: ${chunkM632V57T_js.a.font_weight_medium};
  line-height: ${chunkM632V57T_js.a.line_height_300};
  color: ${chunkS7FZ7BAB_js.c.text_default_text_secondary};
  margin: ${chunkS7FZ7BAB_js.b.spacing_0};

`;

exports.a = c;
exports.b = g;
exports.c = d;
exports.d = _;
exports.e = m;
exports.f = f;
exports.g = h;
exports.h = x;
exports.i = $;
exports.j = y;
exports.k = u;
exports.l = w;
exports.m = z;
exports.n = b;
